import * as React from 'react';
import { ArticleSearchForm, ArticleSearchInputContent } from './components';

export const ArticleSearchInput = () => {
  const id = 'searchArticle';
  return (
    <ArticleSearchForm
      inputId={id}
    >
      <ArticleSearchInputContent
        id={id}
      />
    </ArticleSearchForm>
  );
};
